import { Helmet } from 'react-helmet-async';
import manikchandLogo from '../../assets/images/manikchand_Logo.svg';

const FaqPageHelmet = () => (
  <Helmet>
    {/* SEO Title */}
    <title>Namasteji Manikchand FAQ</title>

    {/* Meta Description */}
    <meta
      name='description'
      content='Find answers to common questions about Namasteji Manikchand Pan Masala. Get help, customer support details, and authentic information about our products, taste, and quality.'
    />

    {/* Keywords */}
    <meta
      name='keywords'
      content='
      Namasteji Manikchand FAQ,
      Namasteji Manikchand help,
      Namasteji Manikchand questions,
      Namasteji Manikchand customer support,
      Namasteji Manikchand pan masala information'
    />

    {/* Canonical URL */}
    <link rel='canonical' href='https://globalmanikchand.in/faq' />

    {/* Open Graph (Facebook, WhatsApp, Instagram) */}
    <meta property='og:type' content='website' />
    <meta property='og:title' content='Manikchand FAQ ' />
    <meta
      property='og:description'
      content='Explore Namasteji Manikchand FAQs for quick help and answers. Learn more about our Pan Masala, customer support, and product information all in one place'
    />
    <meta property='og:url' content='https://globalmanikchand.in/faq' />
    <meta property='og:image' content={window.location.origin + manikchandLogo} />
    <meta property='og:site_name' content='Namasteji Manikchand FAQ' />
    <meta property='og:locale' content='en_IN' />

    {/* Twitter Card */}
    <meta name='twitter:card' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:title' content='Manikchand FAQ ' />
    <meta
      name='twitter:description'
      content='Explore Namasteji Manikchand FAQs for quick help and answers. Learn more about our Pan Masala, customer support, and product information all in one place'
    />
    <meta name='twitter:image' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:site' content='@NamastejiManikchand' />
  </Helmet>
);

export default FaqPageHelmet;
